import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { FlyoutCategory } from "@/redux/modules/value/flyoutCategories/flyoutCategories.types";

type CategoryContextValue = {
    index: number;
    category: FlyoutCategory;
    onMouseEnter: (subCategoryIndex: number) => void;
    onMouseLeave: () => void;
};

type CategoryContextProviderProps = {
    index: number;
    category: FlyoutCategory;
    onMouseEnter: (subCategoryIndex: number) => void;
    onMouseLeave: () => void;
    children: ReactNode;
};

const CategoryContext = createContext<CategoryContextValue | undefined>(
    undefined
);
CategoryContext.displayName = "CategoryContext";

export const CategoryContextProvider = ({
    index,
    category,
    onMouseEnter,
    onMouseLeave,
    children
}: CategoryContextProviderProps) => {
    return (
        <CategoryContext
            value={{
                index: index,
                category: category,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            }}
        >
            {children}
        </CategoryContext>
    );
};

export const useCategoryContext = () => {
    const context = use<CategoryContextValue | undefined>(CategoryContext);

    if (!isDefined(context)) {
        throw new Error(`${CategoryContext.displayName} is undefined.`);
    }

    return context;
};

export const useSubCategory = (index: number) => {
    const { category } = useCategoryContext();

    return {
        category: category.subCategories?.at(index)
    };
};
